import {
  AddPaymentMethodButton,
  PaymentSourceIcon,
} from "features/payment-methods/components";
import type { PaymentSource } from "features/payment-methods/types";

import { Button } from "common/components/ui/Button";
import Skeleton from "common/components/ui/Skeleton";

interface PrimaryPaymentSourceProps {
  paymentSource: PaymentSource;
  onEdit: () => void;
  isLoading: boolean;
}

export default function SubscriptionPaymentSource({
  paymentSource,
  onEdit,
  isLoading,
}: PrimaryPaymentSourceProps) {
  if (isLoading)
    return (
      <div className="flex items-center gap-x-2 rounded-2xl border border-black-200 px-2 py-1.5">
        <Skeleton className="h-6 w-10" />
        <Skeleton className="h-5 w-36" />
        <Skeleton className="ml-auto size-8 rounded-full" />
      </div>
    );

  if (paymentSource) {
    return (
      <div className="flex items-center gap-x-2 rounded-2xl px-2 py-1.5 border border-black-200">
        <PaymentSourceIcon paymentSource={paymentSource} />
        <span className="flex-1 text-nowrap text-left text-sm-bold">
          {paymentSource.type === "card"
            ? `Card ending with ${paymentSource.card.last4}`
            : paymentSource.paypal.email}
        </span>
        <Button
          variant="secondary-purple"
          onClick={onEdit}
          size="sm"
          id="edit-payment-source-button"
          aria-label="edit subscription payment source"
        >
          Edit
        </Button>
      </div>
    );
  }
  return <AddPaymentMethodButton onClick={onEdit} />;
}
